import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { DebugColor } from "./DebugColor";
import { useShowDebugAttributes } from "./DebugOptions";
import { DebugItemPopover } from "./DebugPopover";
import { DebugType } from "./DebugType";
export function CsAttributeDebug() {
    const attribute = useCsAttribute();
    return _jsx(CsAttributeDebugDisplay, { attribute: attribute });
}
export function CsAttributeDebugDisplay(props) {
    const showDebug = useShowDebugAttributes();
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    const { attribute, chipSx, wrapperSx = { pt: "1em" } } = props;
    return (_jsxs(Box, { sx: wrapperSx, children: [_jsx(DebugItemPopover, { item: attribute, color: DebugColor.Attribute, type: DebugType.Attributes, title: attribute.id, chipSx: chipSx }), !attribute.isActive && (_jsx(Chip, { size: "small", color: "warning", label: "inactive", sx: chipSx })), !attribute.isVisible && (_jsx(Chip, { size: "small", color: "warning", label: "invisible", sx: chipSx }))] }));
}
//# sourceMappingURL=CsAttributeDebug.js.map